import { LEGAL_PATHS } from "./paths.js";

/**
 * "Terms agreed", small, right below the checkout's give button, linking to the Terms (GH-812;
 * GH-817). Owner, build 28: counsel holds this is enough to record the agreement.
 */
export function GivingTermsNote() {
  return (
    <p className="giving-terms muted small">
      <a href={LEGAL_PATHS.terms}>Terms agreed</a>
    </p>
  );
}
